import React from 'react';

import { Check } from '@mui/icons-material';

import {
  OrganizationIcon,
  PatientOutlined,
  ProviderOutlined,
  PersonIcon
} from '../Common/components/Icons/icons';

export const settingsTabs = [
  {
    value: 0,
    icon: <PatientOutlined />,
    label: 'PT Settings'
  },
  {
    value: 1,
    icon: <ProviderOutlined />,
    label: 'User Settings'
  },
  {
    value: 2,
    icon: <OrganizationIcon />,
    label: 'Organization Profile'
  },
  {
    value: 3,
    icon: <PersonIcon />,
    label: 'Personal Profile',
    iconSize: 22
  }
];

export const patientColumns = [
  {
    field: 'patient',
    headerName: 'Patient',
    width: '23%',
    primary: true
  },
  {
    field: 'email',
    headerName: 'Email',
    width: '27%'
  },
  {
    field: 'mobile',
    headerName: 'Mobile',
    width: '22%'
  },
  {
    field: 'status',
    headerName: 'Status',
    width: '16%',
    cellSx: value => ({
      color:
        value === 'Active'
          ? '#2E9D42'
          : '#F44336',
      fontWeight: 500
    })
  }
];

export const userColumns = [
  {
    field: 'name',
    headerName: 'Name',
    width: '22%',
    primary: true
  },
  {
    field: 'email',
    headerName: 'Email',
    width: '20%'
  },
  {
    field: 'provider',
    headerName: 'Provider',
    width: '11%',
    align: 'center',
    renderCell: value =>
      value ? (
        <Check sx={{ fontSize: 15 }} />
      ) : (
        ''
      )
  },
  {
    field: 'staff',
    headerName: 'Staff',
    width: '10%',
    align: 'center',
    renderCell: value =>
      value ? (
        <Check sx={{ fontSize: 15 }} />
      ) : (
        ''
      )
  },
  {
    field: 'admin',
    headerName: 'Admin',
    width: '10%',
    align: 'center',
    renderCell: value =>
      value ? (
        <Check sx={{ fontSize: 15 }} />
      ) : (
        ''
      )
  },
  {
    field: 'status',
    headerName: 'Status',
    width: '15%',
    cellSx: value => ({
      color:
        value === 'Active'
          ? '#2E9D42'
          : '#F44336',
      fontWeight: 500
    })
  }
];